export default __webpack_public_path__ + "static/media/dec.22b2c211.svg";